/*==================================================
footer トグルメニュー
==================================================*/
$(function() {
    if (!navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
        $(window).on('load resize', function () {
        var screenWidth = window.innerWidth;
            if (screenWidth <= 575) {
                $('.jsLinkHeading').off('click');
                $('.jsLinkHeading').on('click', function () {
                if($(this).hasClass('open')) {
                    $(this).parent().next('.jsFooterLink').stop().slideUp(500);
                    $(this).removeClass('open');
                }else{
                    $(this).parent().next('.jsFooterLink').stop().slideDown(500);
                    $(this).addClass('open');
                };
                $('.jsLinkHeading').not($(this)).parent().next('.jsFooterLink').stop().slideUp(500);
                $('.jsLinkHeading').not($(this)).removeClass('open');
                });
            };
        });
    } else {
        $(function () {
            $(document).on(oEventNames.end, '.jsLinkHeading', function (event) {
                if (!bIsScrolling) {
                    event.preventDefault();
                    $(this).toggleClass('open');
                    $(this).parent().next('.jsFooterLink').stop().slideToggle(500);
                    $('.jsLinkHeading').not($(this)).parent().next('.jsFooterLink').stop().slideUp(500);
                    $('.jsLinkHeading').not($(this)).removeClass('open');
                }
            });
        });
    };
    var timer = false;
    $(window).resize(function() {
        if (timer !== false) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
            var w = $(window).width();
            if(w > 576 && $('.jsFooterLink').css('display') == 'none') {//576px以上
                $('.jsLinkHeading.open').removeClass('open');
                $('.jsLinkHeading.open').parent().next('.jsFooterLink').stop().slideUp(500);
                $('.jsFooterLink').removeAttr('style'); //または menu.css("display", "block");
            }else if(w <= 575 && $('.jsFooterLink').css('display') == 'block') {//575px以下
                $('.jsFooterLink').removeAttr('style'); //または menu.css("display", "block");
                $('.jsLinkHeading.open').removeClass('open');
            };
        }, 200);
    });
});

// page-top
if ($('.page-top').length) {
    setTimeout(function () {
    var scrollEnd = $('.footer').offset().top;
    var distance = 0;

    $(document).scroll(function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        if (scrollEnd - 500 < distance) { //スクロール距離が『.contact』の位置を超えたら
        $('.page-top').addClass('none'); //class『none』を追加
        } else {
        $('.page-top').removeClass('none'); //class『none』を削除
        }
    });
    }, 1000);//ページ上部からの距離を取得

}